"use client"

import { BLXApplications } from "config/routing"
import type React from "react"
import { selectActivePpSubId, useAppSelector } from "services"
import { usePPRouteNavigationLinkItems } from "utils/routeBuilders/pp/usePPRouteNavigationLinkItems"
import { NavLinkItem } from "./components"
import AppNavigationContainer from "./components/AppNavigationContainer"
import NavigationAccordion from "./components/NavigationAccordion"

const OperationsNavigation: React.FC = () => {
    const activePPSub = useAppSelector(selectActivePpSubId)

    const {
        operationsAnalyticsConfig,
        operationsSettingsConfig,
        operationstApplicationNavigationConfig
    } = usePPRouteNavigationLinkItems()

    const navDisabled = !activePPSub || activePPSub.length <= 0

    return (
        <AppNavigationContainer app={BLXApplications.Operations}>
            {operationstApplicationNavigationConfig.map((navLinkItem, i) => (
                <NavLinkItem
                    item={navLinkItem}
                    key={navLinkItem.application + i}
                    disabled={navDisabled}
                />
            ))}
            <NavigationAccordion
                disabled={navDisabled}
                accordionItems={[
                    {
                        label: "Analytics",
                        links: operationsAnalyticsConfig
                    },
                    {
                        label: "settings",
                        links: operationsSettingsConfig
                    }
                ]}
                closedIndexArray={[1]}
            />
        </AppNavigationContainer>
    )
}

export default OperationsNavigation
